import MSEPlayer from '../components/player/MsePlayer'
import {useParams} from 'react-router-dom'
import {useEffect, useState} from 'react'
import ComponentSpinner from '@src/@core/components/spinner/Loading-spinner'

const Live = () => {
  const {cameraName} = useParams<{cameraName?: string}>()
  const camera = cameraName || ''
  const [isPlaying, setIsPlaying] = useState(false)

  useEffect(() => {
    // when camera changes, show loader until playback starts
    setIsPlaying(false)
  }, [camera])
  return (
    <div className="live-page">
      <style>{`
        html,
        body,
        #root {
          height: 100%;
          width: 100%;
          margin: 0;
          background: #000;
        }

        .live-page {
          min-height: 100vh;
          min-width: 100vw;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #000;
        }

         .stream-container { width: 100%; height: 100%; }

        .live-video {
          width: 100%;
          height: 100%;
          max-width: 100vw;
          max-height: 100vh;
          object-fit: cover;          /* fills all space, crops if needed */
          object-position: center;    /* keep subject centered */
          background: #000;
        }

        .stream-container { position: relative; }
        .loading-overlay {
          position: absolute;
          inset: 0;
          display: flex;
          align-items: center;
          justify-content: center;
          background: rgba(0,0,0,0.4);
          z-index: 2;
        }
      `}</style>

      <div className="stream-container">
        {!isPlaying && (
          <div className="loading-overlay">
            <ComponentSpinner />
          </div>
        )}
        <MSEPlayer
          key="mse_"
          className="live-video"
          camera={camera}
          playbackEnabled
          audioEnabled={false}
          volume={0}
          playInBackground={false}
          getStats={false}
          setStats={() => {}}
          onPlaying={() => setIsPlaying(true)}
          pip={false}
          setFullResolution={() => {}}
          onError={() => setIsPlaying(false)}
        />
      </div>
    </div>
  )
}

export default Live
